import ACTION from '../action_constant';

function profile(state = {
  profileInfo: {},
  profile: {},
  reviews: [],
  reviewList: [],
  notifications :{}
}, action) {
  let notifications,fullState;
  switch (action.type) {
    case ACTION.PROFILE.ADD_PROFILE_DATA:
        return Object.assign({}, state, {profileInfo: action.data.profileData});

    case ACTION.PROFILE.UPDATE_PROFILE:
        return Object.assign({}, state, {profile:action.data.profile})

    case ACTION.PROFILE.PROFILE_REVIEWS:
        action.data.reviews.forEach((ratingObj, index) => {
            state.reviews.push(ratingObj);
        })
        return Object.assign({}, state, {reviews:state.reviews, reviewsLength: action.data.reviews.length});

    case ACTION.PROFILE.GET_NOTIFICATIONS:
        notifications = action.data;
        return Object.assign({}, state, {notifications : notifications});

    case ACTION.PROFILE.DELETE_NOTIFICATIONS:
          fullState =  Object.assign({} , state)
          notifications = fullState.notifications;
          for(let i =0;i< notifications.notifications.length;i++ ){
            if(notifications.notifications[i].id == action.data.notificationIds[0])
            {
              notifications.notifications.splice(i ,1)
              break;
            }
          }
        return Object.assign({}, state ,{notifications : notifications});

    case ACTION.PROFILE.READ_NOTIFICATION :
          fullState =  Object.assign({} , state)
          notifications = fullState.notifications;
          for(let i =0;i< notifications.notifications.length;i++ ){
            if(notifications.notifications[i].id == action.data.notificationIds[0])
            {
              notifications.notifications[i].isRead = true
              break;
            }
          }
            return Object.assign({}, state ,{notifications : notifications});

    default:
      return state;
  }
}


export default profile;



// WEBPACK FOOTER //
// app/profile/profile_reducers.jsx